import {notificationStore} from './notifications.store';
import {Injectable, Signal} from '@angular/core';
import {combineLatest, Observable} from 'rxjs';
import {
  GeneralAnnouncementDto,
  NotificationStatus,
  NotificationType,
  UserNotificationDto,
} from '../../../types/notifications.type';
import {map} from 'rxjs/operators';
import {select} from '@ngneat/elf';
import {toSignal} from '@angular/core/rxjs-interop';
import {userInfoStore} from '../user-info/user-info.store';

@Injectable({providedIn: 'root'})
export class NotificationsQuery {
  public personalNotifications$: Observable<UserNotificationDto[]>;
  public personalNotDismissedNotifications$: Observable<UserNotificationDto[]>;
  public personalNotDismissedNotificationsSignal: Signal<UserNotificationDto[]>;
  public generalAnnouncements$: Observable<GeneralAnnouncementDto[]>;
  public isLoading$: Observable<boolean>;

  constructor() {
    this.personalNotifications$ = combineLatest([
      userInfoStore.pipe(select(state => state.userInfo.trialInfo)),
      notificationStore.pipe(select(state => state.personalNotifications)),
    ]).pipe(
      map(([trialInfo, notifications]) =>
        notifications.filter(
          notification =>
            !(
              [NotificationType.AccountBillingAlertsNoCardTrialExpires].includes(notification.type) &&
              !trialInfo.isTrialNoCardExpired &&
              !trialInfo.isTrialNoCard
            ),
        ),
      ),
    );

    this.personalNotDismissedNotifications$ = combineLatest([
      userInfoStore.pipe(select(state => state.userInfo.trialInfo)),
      notificationStore.pipe(select(state => state.personalNotifications)),
    ]).pipe(
      map(([trialInfo, notifications]) =>
        notifications.filter(
          notification =>
            notification.status === NotificationStatus.NEW ||
            ([NotificationType.AccountBillingAlertsNoCardTrialExpires].includes(notification.type) &&
              trialInfo.isTrialNoCardExpired),
        ),
      ),
    );

    this.personalNotDismissedNotificationsSignal = toSignal(this.personalNotDismissedNotifications$);

    this.generalAnnouncements$ = notificationStore.pipe(select(state => state.generalAnnouncements));
    this.isLoading$ = notificationStore.pipe(select(state => state.isLoading));
  }
}
